// A rule between groups.
//
// Two pixels, the same weight every plate's edge is: a hairline reads as a
// rendering artefact against these borders rather than as a division.

import { styled } from "@mui/material/styles";

export interface DividerOwnProps {
  vertical?: boolean;
}

export const Divider = styled("hr", {
  shouldForwardProp: (prop: string) => prop !== "vertical"
})<DividerOwnProps>(({ theme, vertical }) => ({
  border: 0,
  ...(vertical
    ? {
        width: 2,
        alignSelf: "stretch",
        margin: `0 ${theme.kit.space.md}px`,
        background: theme.kit.color.line
      }
    : {
        width: "100%",
        borderTop: `2px solid ${theme.kit.color.line}`,
        margin: `${theme.kit.space.md}px 0`
      })
}));
